import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TabService } from '../services/dynamictools/title.service';

@Injectable({
  providedIn: 'root'
})
export class TitleResolver implements Resolve<void> {
  constructor(private tabService: TabService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const title = route.data['title'];
    if (title) {
      this.tabService.setTitle(title);
    }
  }
}